import { useCurrentRefinements } from 'react-instantsearch'

const FilterLabels = () => {
  const { items, refine } = useCurrentRefinements()

  return (
    <ul className="flex flex-row flex-wrap justify-start content-between gap-[8px]">
      {items?.map((item) => (
        <>
          {item.refinements.map((refinement, i) => (
            <li
              key={[item.indexName, item.label, i].join('/')}
              className="italic md:text-[15px] text-sm h-[32px] rounded-[10px] shadow-[0px_1px_2px_rgba(0,0,0,0.25)] focus:outline-none focus:border-none bg-black text-white md:h-[29px] flex justify-between items-center md:w-fit p-[4px]"
            >
              <span key={refinement.label + i} className="flex items-center">
                <span>{refinement.label}</span>
                <button type="button" onClick={() => refine(refinement)} className="p-1">
                  ✕
                </button>
              </span>
            </li>
          ))}
        </>
      ))}
    </ul>
  )
}

export default FilterLabels
